module.exports = __webpack_public_path__ + "static/media/BM 06.0b9797aa.png";